import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LeadSource, LeadSourceCollection} from '../model/lead-source.model';
import {HttpClient} from '@angular/common/http';
import {map, retry} from 'rxjs/operators';
import {LEAD_SOURCES_URL} from '../../api-config';

@Injectable({
  providedIn: 'root'
})
export class LeadSourceService {

  constructor(private httpClient: HttpClient) {
  }

  getCurrentLeadSource(): Observable<LeadSource> {
    return this.httpClient.get<LeadSourceCollection>(LEAD_SOURCES_URL).pipe(retry(5),
      map(collection => {
        if (collection?._embedded?.leadSources) {
          if (collection._embedded.leadSources.length > 1) {
            console.error('More than one leadSource found', collection._embedded.leadSources);
          }
          return collection._embedded.leadSources[0];
        }
        return null;
      }));
  }
}
